import { z } from 'zod';

/// ////////////////////////////////////////////
/// パスに設定している値を明示的に定義する
/// ////////////////////////////////////////////

const PinpointPathModel = z.object({
  project: z.string(),
  policy: z.string(),
  activityId: z.string(),
  routeIndicatorId: z.string(),
  activityIndicatorId: z.string(),
  legalBasis: z.string(),
  plan: z.string(),
  subsidyRate: z.string(),
  paymentGroup: z.string(),
  contractorPaymentId: z.string(),
  summaryAndResponseProcess: z.string(),
  otherIndicatedItemAndResponseReason: z.string(),
  rootActivity: z.string(),
  expenditureCart: z.string(),
  fundBusinessId: z.string(),
  amountBreakdownName: z.string(),
  paymentId: z.string(),
});

export const PartialPinpointPathModel = PinpointPathModel.partial();

export const projectPathObj = PinpointPathModel.pick({ project: true });
export const policyProjectPathObj = PinpointPathModel.pick({
  project: true,
  policy: true,
});
export const legalBasesProjectPathObj = PinpointPathModel.pick({
  project: true,
  legalBasis: true,
});
export const planProjectPathObj = PinpointPathModel.pick({
  project: true,
  plan: true,
});
export const subsidyRateAndSoOnProjectPathObj = PinpointPathModel.pick({
  project: true,
  subsidyRate: true,
});
export const paymentGroupProjectPathObj = PinpointPathModel.pick({
  project: true,
  paymentGroup: true,
});
export const paymentAmountBreakdownPathObj = PinpointPathModel.pick({
  project: true,
  paymentGroup: true,
  paymentId: true,
  amountBreakdownName: true,
});
export const summaryAndResponseProcessProjectPathObj = PinpointPathModel.pick({
  project: true,
  summaryAndResponseProcess: true,
});
export const otherIndicatedItemAndResponseReasonProjectPathObj =
  PinpointPathModel.pick({
    project: true,
    otherIndicatedItemAndResponseReason: true,
  });
export const activitiesActivityFlowProjectPathObj = PinpointPathModel.pick({
  project: true,
  routeIndicatorId: true,
  activityIndicatorId: true,
});
export const rootActivityPathObj = PinpointPathModel.pick({
  project: true,
  routeIndicatorId: true,
  // 現在使わないですが、将来的に使う可能性があるため定義
  activityId: true,
});
export const budgetAndExecutionPathObj = PinpointPathModel.pick({
  project: true,
  expenditureCart: true,
});
export const contractorPaymentIdProjectPathObj = PinpointPathModel.pick({
  project: true,
  contractorPaymentId: true,
});
export const fundBusinessIdProjectPathObj = PinpointPathModel.pick({
  project: true,
  fundBusinessId: true,
});
